<template>
  <div>
    <div v-if="type == 'read'" @click="allWordDialog = true" style="color: #334970ee">
      <i class="all-word el-icon-notebook-1"></i>
      <div style="font-size: 1.2em">全部单词</div>
    </div>


    <el-dialog :visible.sync="allWordDialog" width="50%" :show-close="false" center>
      <el-row>
        <el-col style="font-size: 24px; margin: 15px 0; text-align: center" :span="6" v-for="word in words" :key="word.id">
          <span>{{word.content1}}</span>
        </el-col>
      </el-row>
      
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['words','type'],
  data() {
    return {
      allWordDialog: false
    }
  },
}
</script>

<style scoped>
.all-word{
  font-size: 4em;
  margin: 20px auto 0 auto;
}
</style>
